import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';

import {AuthService} from "@services";
import {AppBaseComponent} from "@utils";

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss']
})
export class FeatureComponent extends AppBaseComponent implements OnInit {
  isIframe = false;

  constructor(private router: Router,
              private authService: AuthService) {
    super();
  }

  ngOnInit() {


    if(localStorage.getItem("currentUser") != null){
      let usuarioLogueado = this.authService.getLoggedUser();

      if (usuarioLogueado != null && !usuarioLogueado.tieneCodigoVentanilla) {
        super.popUpRegistroNaturalJuridica(this.router);
      } else if (usuarioLogueado != null && !usuarioLogueado.aceptoPoliticaSeguridad ) {
        super.popUpAceptarPoliticaDatos(this.router);
      }
    }



    this.isIframe = window !== window.parent && !window.opener;
  }


}
